import React from "react";

import { Table, TableRow, TableBody } from "@material-ui/core";
import { DateEstimateProblems } from "../../../generated/graphql";
import { CustomTable } from "../../shared/CustomTable";
import { ColorizedTableCell, CustomTableCell, CustomTableHead, CustomTableHeaderCell } from "../../shared/CustomTable/CustomTable.style";
import { convertDateStringToLocaleHandler } from "../../shared/Utils/ConvertOperations/convertDateStringToLocaleHandler";

interface IDateEstimateProps {
  tasks: DateEstimateProblems[];
}

const headers = [
  'Ключ задачи',
  'Название',
  'Дата начала план',
  'Дата конца план',
];

export const DateEstimate = ({ tasks }: IDateEstimateProps) => {
  const content = (
    <Table>
      <CustomTableHead>
        <TableRow>
          {headers.map(header => (
            <CustomTableHeaderCell
              key={header}
              width={150}
            >
              {header}
            </CustomTableHeaderCell>
          ))}
        </TableRow>
      </CustomTableHead>

      <TableBody>
        {tasks.length
          ? (tasks.map(task => (
            <TableRow
              key={task.key}
            >
              {[
                task.key,
                task.name,
                convertDateStringToLocaleHandler(task.startDateEstimate),
                convertDateStringToLocaleHandler(task.finishDateEstimate),
              ].map((field, i) => (
                <ColorizedTableCell
                  key={`${i} ${field}`}
                  number={field ? 0 : -1 }
                >
                  {field}
                </ColorizedTableCell>
              ))}
            </TableRow>
          )))
          : (
            <TableRow>
              <CustomTableCell colSpan={4} >Задачи отсутствуют</CustomTableCell>
            </TableRow>
          )
        }
      </TableBody>
    </Table>
  )

  return (
    <CustomTable data={tasks} tableContent={content} />
  )
}